import { useGlobalContext } from '../Context/Authentation';
import { toast } from 'react-toastify';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

export default function DeleteNoteModel(props) {
    const navigate = useNavigate();
    const { user, setrefresh, refresh } = useGlobalContext();

    const DeleteHandler = async () => {
        var toast1;
        try {
            toast1 = toast.loading("deleting Note", {
                position: "bottom-center",
                theme: "dark",
            })

            const config = { headers: { Authorization: `Bearer ${user?.token}` } }
            await axios.delete(`https://quick-notes-c09v.onrender.com/api/notes/delete/${props.NoteId}`, config);



            toast.update(toast1,
                {
                    render: "Note deleted",
                    type: "success",
                    isLoading: false,
                    position: "bottom-center",
                    autoClose: 5000,
                    theme: "dark",
                    closeOnClick: true,
                });

            navigate("/Home/allNotes")
        } catch (error) {
            console.log(error);

            toast.update(toast1,
                {
                    render: "Unable to delete Note",
                    type: "error",
                    isLoading: false,
                    position: "bottom-center",
                    autoClose: 5000,
                    theme: "dark",
                    closeOnClick: true,
                });

        }
        setrefresh(!refresh)
    }

    return (
        <div className="modal " id="deleteNotes" tabIndex="-1" aria-labelledby="deleteNotesLabel" aria-hidden="true" data-easein="bounce">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5 text" id="deleteNotesLabel" style={{ color: "black" }}>Sure to Delete : &nbsp;
                            <span style={{ color: "red" }}>{props?.title}</span>
                            &nbsp;? </h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div className="modal-footer" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" data-bs-dismiss="modal" className="btn btn-danger" onClick={DeleteHandler}>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
